import React, { PureComponent } from 'react'
import { object } from 'prop-types'
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap'
import { translate } from 'react-i18next'
import { StickyTable, Row, Cell } from 'react-sticky-table'
import { range } from 'lodash'

import { Player } from './Player/Player'
import { Race } from './Race/Race'
import './McGame.css'

@translate()
export class McGameTabSeasons extends PureComponent {
    static propTypes = {
        seasons: object.isRequired
    }

    state = {
        activeTab: 0
    }

    componentWillMount() {
        const { seasons, requestedSeason, totalRaces } = this.props
        this.races = range(1, totalRaces + 1)
        this.setState({ activeTab: requestedSeason - 1 })
    }

    onSelectNav = index => {
        const { onChangeTab } = this.props
        this.setState({ activeTab: index })
        onChangeTab && onChangeTab(index + 1)
    }

    renderItem = (item, index) => <Race key={`race-${index}`} race={item} />

    renderTableHeader = race => (
        <Cell key={race}>
            <div className="ST-Header-race">{`RACE ${race}`}</div>
        </Cell>
    )

    renderTableRow = (player, index) => {
        const { playerName, playerNickname, playerCode, investment, races } = player
        return (
            <Row key={`row-${index}`}>
                <Player key={`player-${index}`} className="ST-Cell-race" name={playerName} nickname={playerNickname} code={playerCode} investment={investment} />
                {races.map(this.renderItem)}
                {range(this.props.totalRaces - races.length).map(this.renderItem)}
            </Row>
        )
    }

    renderTable = players => (
        <StickyTable>
            <Row>
                <Cell>
                    <div className="ST-Header-race">Player</div>
                </Cell>
                {this.races.map(this.renderTableHeader)}
            </Row>
            {players.map(this.renderTableRow)}
        </StickyTable>
    )

    renderNavItem = (link, index) => {
        const { currentSeason, totalSeasons, currentRace, totalRaces } = this.props
        const disabled = currentRace < totalRaces && currentSeason <= index
        return (
            <NavItem key={index}>
                <NavLink className={this.state.activeTab === index ? 'active' : ''} onClick={() => this.onSelectNav(index)} disabled={disabled}>
                    {this.props.t('mc.game.season', { count: index + 1 })}
                </NavLink>
            </NavItem>
        )
    }

    renderNavPane = (val, index) => (
        <TabPane tabId={index} key={`season-${index}`}>
            {this.props.seasons[index + 1] ? <div className="McGame-Table__wrapper">{this.renderTable(this.props.seasons[index + 1])}</div> : null}
        </TabPane>
    )

    render() {
        const { seasons, currentSeason, totalSeasons = 0, t } = this.props
        const { activeTab } = this.state
        return (
            <div className="McGame-Tab-Seasons">
                <div className="header">
                    <Nav tabs className="nav-tabs--subtabs">
                        {range(totalSeasons).map(this.renderNavItem)}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab}>{range(totalSeasons).map(this.renderNavPane)}</TabContent>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/MC/Game/McGameTabSeasons.js